/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Confirmationemailsend2Inputs */

const de__field_confirmationemailsend2 = /** @type {(inputs: _Field_Confirmationemailsend2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestätigungsemail gesendet`)
};

/**

* @param {_Field_Confirmationemailsend2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_confirmationemailsend2 = /** @type {((inputs?: _Field_Confirmationemailsend2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Confirmationemailsend2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_confirmationemailsend2(inputs)
});
export { _field_confirmationemailsend2 as "_field_confirmationEmailSend" }